/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import "./LookupView.scss";
import { CssUtils } from "../CssUtils";
import { T } from "../Localization";
import { LookupControlFactory } from "./LookupControlFactory";
var LookupControlIndex = "data-lookup-index";
export var LookupDataValueAttribute = "data-value";
var LookupView = /** @class */ (function () {
    function LookupView(input) {
        var _this = this;
        this.input = input;
        this.initDataLoaded = false;
        input.removeAttribute("list");
        input.autocomplete = "off";
        CssUtils.addClass(input, "lookup-behavior");
        this.lookupDefaultValue = this.readDefaultValue();
        this.controlIndex = LookupView.counter++;
        this.divIdentifier = "lookup-popup-div-".concat(this.controlIndex);
        this.ulIdentifier = "lookup-popup-ul-".concat(this.controlIndex);
        input.addEventListener("input", function () { return (_this.selectedItem = null); });
        input.addEventListener("keydown", function (e) { return _this.onKeydown(e); });
        input.addEventListener("keyup", function (e) { return _this.onKeyup(e); });
        input.addEventListener("focus", function () { return _this.setPopupVisible(true); });
        input.addEventListener("blur", function () {
            _this.setPopupVisible(false);
            if (!_this.selectedItem && !_this.input.value) {
                _this.initDataLoaded = false;
            }
        });
        input.addEventListener("click", function () {
            if (!_this.initDataLoaded) {
                _this.initDataLoaded = true;
                _this._onInputChange(false, true);
            }
        });
    }
    LookupView.prototype.clearSelectedItem = function () {
        this.selectedItem = null;
        this.input.value = "";
        this.setElementLookupValue(this.input, null);
    };
    LookupView.prototype.getParentValue = function () {
        var _a;
        var lookupDiv = this.input.closest('.lookupFormFieldBlock');
        var parentFieldId = lookupDiv === null || lookupDiv === void 0 ? void 0 : lookupDiv.getAttribute('data-parent-fieldid');
        var parentElement = (_a = this.input.form) === null || _a === void 0 ? void 0 : _a.querySelector("input[id=\"".concat(parentFieldId, "\"]"));
        var parentValue = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getAttribute(LookupDataValueAttribute);
        if (!!parentValue) {
            var _b = __read(parentValue.split(",", 2), 2), entityName = _b[0], entityValue = _b[1];
            return JSON.stringify({ Id: entityValue, LogicalName: entityName });
        }
        return undefined;
    };
    LookupView.prototype.IsPopupListAtTheEndOfScroll = function () {
        return this.isAtEndOfScroll(this.popupList);
    };
    LookupView.prototype.registerOnInputChange = function (onInputChange) {
        this._onInputChange = onInputChange;
    };
    LookupView.prototype.registerOnLoadMoreData = function (onLoadMoreData) {
        this._onLoadMoreData = onLoadMoreData;
    };
    LookupView.prototype.updateInitDataLoadedState = function (isInitDataLoaded) {
        this.initDataLoaded = isInitDataLoaded;
    };
    LookupView.prototype.registerOnRefreshChildrenElements = function (onRefreshChildrenElements) {
        this._onRefreshChildrenElements = onRefreshChildrenElements;
    };
    Object.defineProperty(LookupView.prototype, "inputValue", {
        get: function () {
            return this.input.value;
        },
        enumerable: false,
        configurable: true
    });
    LookupView.prototype.getDefaultValue = function () {
        return this.lookupDefaultValue;
    };
    LookupView.prototype.setDefaultItem = function (item) {
        this.selectedItem = item;
    };
    LookupView.prototype.onLoadingStarted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var list, loadingItem, content, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        CssUtils.addClass(this.input, "lookup-loading");
                        list = this.popupList;
                        loadingItem = list.querySelector(".ui-loading-item");
                        if (loadingItem) {
                            return [2 /*return*/];
                        }
                        loadingItem = document.createElement("li");
                        loadingItem.className = "ui-loading-item";
                        content = document.createElement("div");
                        content.className = "ui-loading-item-wrapper";
                        content.setAttribute("role", "option");
                        return [4 /*yield*/, T("LookupLoading")];
                    case 1:
                        message = _a.sent();
                        content.innerText = message;
                        loadingItem.appendChild(content);
                        list.appendChild(loadingItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    LookupView.prototype.onLoadingFinished = function () {
        CssUtils.removeClass(this.input, "lookup-loading");
        var list = this.popupList;
        var loadingItem = list.querySelector(".ui-loading-item");
        if (loadingItem) {
            list.removeChild(loadingItem);
        }
    };
    LookupView.prototype.onRetry = function (onRetryClick) {
        var item = this.popupList.querySelector(".ui-retry-item");
        if (item) {
            this.popupList.removeChild(item);
        }
        onRetryClick();
    };
    LookupView.prototype.onError = function (errorKey, onErrorRefreshClick) {
        return __awaiter(this, void 0, void 0, function () {
            var list, listItem, retryContentWrapper, retryText, _a, buttonContent, retryButton, label;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        list = this.popupList;
                        listItem = document.createElement("li");
                        listItem.className = "ui-retry-item";
                        retryContentWrapper = document.createElement("div");
                        retryContentWrapper.className = "ui-retry-item-wrapper";
                        retryText = document.createElement("div");
                        retryText.className = "ui-retry-text";
                        retryText.setAttribute("role", "option");
                        _a = retryText;
                        return [4 /*yield*/, T(errorKey)];
                    case 1:
                        _a.innerText = _b.sent();
                        buttonContent = document.createElement("div");
                        buttonContent.className = "ui-retry-button-wrapper";
                        retryButton = document.createElement("button");
                        retryButton.type = "button";
                        return [4 /*yield*/, T("Reload")];
                    case 2:
                        label = _b.sent();
                        retryButton.className = "ui-retry-button";
                        retryButton.setAttribute("aria-label", label);
                        retryButton.setAttribute("title", label);
                        retryButton.textContent = label;
                        retryButton.onmousedown = function (event) {
                            onErrorRefreshClick();
                            event.preventDefault();
                        };
                        buttonContent.appendChild(retryButton);
                        retryContentWrapper.appendChild(retryText);
                        retryContentWrapper.appendChild(buttonContent);
                        listItem.appendChild(retryContentWrapper);
                        list.appendChild(listItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    LookupView.prototype.appendItems = function (items) {
        var _this = this;
        var list = this.popupList;
        items.forEach(function (item) {
            var listItem = _this.renderItem(item);
            list.appendChild(listItem);
        });
    };
    LookupView.prototype.resetControl = function () {
        this.popupList.innerHTML = "";
    };
    LookupView.prototype.setPopupVisible = function (visible) {
        var popupElement = this.popupElement;
        if (visible) {
            this.updateListWidth(this.popupList);
            var boundingClientRect = this.input.getBoundingClientRect();
            var positionParent = popupElement.parentElement;
            while (positionParent &&
                positionParent.parentElement !== positionParent &&
                window.getComputedStyle(positionParent).position === "static") {
                positionParent = positionParent.parentElement;
            }
            if (positionParent) {
                var positionRect = positionParent.getBoundingClientRect();
                popupElement.style.top = boundingClientRect.top + boundingClientRect.height + positionParent.scrollTop - positionRect.top + "px";
                popupElement.style.left = boundingClientRect.left + positionParent.scrollLeft - positionRect.left + "px";
            }
            else {
                popupElement.style.top = boundingClientRect.top + boundingClientRect.height + window.pageYOffset + "px";
                popupElement.style.left = boundingClientRect.left + window.pageXOffset + "px";
            }
            CssUtils.addClass(popupElement, "ui-selectmenu-open");
        }
        else {
            if (!this.selectedItem) {
                this.input.value = "";
            }
            CssUtils.removeClass(popupElement, "ui-selectmenu-open");
        }
    };
    Object.defineProperty(LookupView.prototype, "controlIndex", {
        get: function () {
            var index = this.input.getAttribute(LookupControlIndex);
            if (index && index.length) {
                return parseInt(index);
            }
            return -1;
        },
        set: function (value) {
            this.input.setAttribute(LookupControlIndex, value.toString());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupView.prototype, "popupElement", {
        get: function () {
            var popupElement = document.getElementById(this.divIdentifier);
            if (!popupElement) {
                popupElement = this.renderPopupElement();
            }
            return popupElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupView.prototype, "popupList", {
        get: function () {
            return this.popupElement.querySelector("#".concat(this.ulIdentifier));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupView.prototype, "selectedItem", {
        get: function () {
            return this.getElementLookupValue(this.input);
        },
        set: function (item) {
            if (item) {
                this.input.value = item.value;
                this.input.dispatchEvent(new Event("change"));
            }
            var selectedItem = this.selectedItem;
            if ((item === null || item === void 0 ? void 0 : item.entityId) === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.entityId) && (item === null || item === void 0 ? void 0 : item.entityName) === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.entityName)) {
                // same item selected
                return;
            }
            this.setElementLookupValue(this.input, item);
            this.childrenInputs.forEach(function (child) {
                var _a;
                var childView = (_a = LookupControlFactory.getLookupFieldControlsFromInput(child)) === null || _a === void 0 ? void 0 : _a.view;
                childView === null || childView === void 0 ? void 0 : childView._onRefreshChildrenElements();
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupView.prototype, "childrenInputs", {
        get: function () {
            var _a;
            var results = [];
            var childElements = (_a = this.input.form) === null || _a === void 0 ? void 0 : _a.querySelectorAll("div[data-parent-fieldid=\"".concat(this.input.id, "\"]"));
            childElements === null || childElements === void 0 ? void 0 : childElements.forEach(function (childElement) {
                var fieldName = childElement.getAttribute("data-targetproperty");
                var childInput = childElement.querySelector("input[name=\"".concat(fieldName, "\"]"));
                if (childInput) {
                    results.push(childInput);
                }
            });
            return results;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookupView.prototype, "highlightedItem", {
        get: function () {
            var highlightedItems = this.popupElement.querySelectorAll("li.ui-state-active");
            if (highlightedItems && highlightedItems.length !== 0) {
                var element = highlightedItems.item(0);
                return this.getElementLookupValue(element, element.innerText);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    LookupView.prototype.updateListWidth = function (list) {
        var boundingClientRect = this.input.getBoundingClientRect();
        list.style.width = boundingClientRect.width + "px";
    };
    LookupView.prototype.renderPopupElement = function () {
        var _this = this;
        var result = document.createElement("div");
        result.className = "ui-selectmenu-menu ui-front";
        result.id = this.divIdentifier;
        var list = document.createElement("ul");
        list.id = this.ulIdentifier;
        this.updateListWidth(list);
        list.setAttribute("role", "listbox");
        list.className = "ui-menu ui-corner-bottom ui-widget ui-widget-content";
        result.appendChild(list);
        list.onscroll = function (event) {
            var element = event.target;
            if (_this.isAtEndOfScroll(element)) {
                _this._onLoadMoreData();
            }
        };
        this.input.insertAdjacentElement("afterend", result);
        list.onmousedown = function (event) {
            event.preventDefault();
        };
        return result;
    };
    LookupView.prototype.setElementLookupValue = function (element, item) {
        if (element) {
            if (item) {
                element.setAttribute(LookupDataValueAttribute, "".concat(item.entityName, ",").concat(item.entityId));
                return;
            }
            element.removeAttribute(LookupDataValueAttribute);
        }
    };
    LookupView.prototype.getElementLookupValue = function (element, value) {
        if (value === void 0) { value = null; }
        if (element) {
            var attributeValue = element.getAttribute(LookupDataValueAttribute);
            if (attributeValue && attributeValue.length) {
                var parts = attributeValue.split(",");
                return { entityName: parts[0], entityId: parts[1], value: value };
            }
        }
        return null;
    };
    LookupView.prototype.renderItem = function (item) {
        var _this = this;
        var listItem = document.createElement("li");
        listItem.className = "ui-menu-item";
        this.setElementLookupValue(listItem, item);
        listItem.onmouseenter = function () {
            var siblings = listItem.parentElement.children;
            for (var i = 0; i < siblings.length; i++) {
                CssUtils.removeClass(siblings.item(i), "ui-state-active");
            }
            CssUtils.addClass(listItem, "ui-state-active");
        };
        var content = document.createElement("div");
        content.className = "ui-menu-item-wrapper";
        content.setAttribute("role", "option");
        content.innerText = item.value;
        listItem.appendChild(content);
        content.onmousedown = function () {
            _this.selectedItem = item;
            _this.setPopupVisible(false);
            _this.input.blur();
        };
        return listItem;
    };
    LookupView.prototype.moveActiveSelection = function (offset) {
        var selectedItem;
        var items = this.popupElement.querySelectorAll("li:not(.ui-loading-item)");
        for (var i = 0; i < items.length; i++) {
            var item = items.item(i);
            if (CssUtils.hasClass(item, "ui-state-active")) {
                CssUtils.removeClass(item, "ui-state-active");
                selectedItem = items.item(i);
                if (i + offset < items.length && i + offset >= 0) {
                    selectedItem = items.item(i + offset);
                    break;
                }
            }
        }
        if (!selectedItem && items.length > 0) {
            selectedItem = items.item(0);
        }
        CssUtils.addClass(selectedItem, "ui-state-active");
        var list = this.popupList;
        if (selectedItem && list.scrollHeight > list.clientHeight) {
            var scrollBottom = list.clientHeight + list.scrollTop;
            var elementBottom = selectedItem.offsetTop + selectedItem.offsetHeight;
            if (elementBottom > scrollBottom) {
                list.scrollTop = elementBottom - list.clientHeight;
            }
            else if (selectedItem.offsetTop < list.scrollTop) {
                list.scrollTop = selectedItem.offsetTop;
            }
        }
    };
    LookupView.prototype.onKeydown = function (event) {
        switch (event.key) {
            case "Down": // IE/Edge specific value
            case "ArrowDown":
                this.moveActiveSelection(1);
                event.preventDefault();
                return;
            case "Up": // IE/Edge specific value
            case "ArrowUp":
                this.moveActiveSelection(-1);
                event.preventDefault();
                return;
            case "Enter":
                var item = this.highlightedItem;
                if (item) {
                    this.selectedItem = item;
                    this.setPopupVisible(false);
                    this.input.blur();
                }
                // Do something for "enter" or "return" key press.
                event.preventDefault();
                return;
        }
    };
    LookupView.prototype.onKeyup = function (event) {
        switch (event.key) {
            case "Down": // IE/Edge specific value
            case "ArrowDown":
                event.preventDefault();
                return;
            case "Up": // IE/Edge specific value
            case "ArrowUp":
                event.preventDefault();
                return;
            case "Enter":
                event.preventDefault();
                return;
        }
        if (this._onInputChange) {
            this._onInputChange(false, true);
        }
    };
    LookupView.prototype.isAtEndOfScroll = function (element) {
        if (!element)
            return false;
        if (element.clientHeight === 0 || element.scrollHeight <= element.clientHeight) {
            return false;
        }
        var tolerance = 2; // Allow small variations for zoom issues
        return Math.abs(element.scrollHeight - (element.clientHeight + element.scrollTop)) < tolerance;
    };
    LookupView.prototype.readDefaultValue = function () {
        var _a, _b, _c;
        var lookupTargets = JSON.parse(((_a = this.input) === null || _a === void 0 ? void 0 : _a.parentElement.getAttribute("data-lookuptargets")) || "[]");
        return (_c = (_b = lookupTargets.find(function (e) { return e.DefaultValue; })) === null || _b === void 0 ? void 0 : _b.DefaultValue) === null || _c === void 0 ? void 0 : _c.name;
    };
    LookupView.counter = 0;
    return LookupView;
}());
export { LookupView };
